export default __webpack_public_path__ + "static/media/logo_Ethics-old.30571ccc.svg";